<template>
    <div class="codelab-sound-record">
        <div class="top">
            <span class="back" @click="backClick">
                <svg-icon href="#codelab-record-back" width="26" height="26"></svg-icon>
            </span>
            <div class="record-status">
                <span class="status-symbol" v-if="status === 1"></span>
                <span class="status-text">
                    {{statusTexts[status]}}
                </span>
            </div>
        </div>
        <div class="bottom">
            
            <div>
                <span v-if="status === 0" class="btn-control record-btn" :class="{active: status === 1}" @click="startRecord">
                    <svg-icon href="#codelab-record-add" width="50" height="50"></svg-icon>
                </span>
                <span v-if="status === 1" class="btn-control stop-record-btn" :title="$t('text_stop_record')" :class="{active: status === 1}" @click="stopRecord">
                    <el-progress
                    class="record-progress"
                    type="circle"
                    :width="100"
                    :stroke-width="5"
                    :percentage="recordPercent"
                    color="url(#line-grad2)"
                    :show-text="false"
                    >
                    </el-progress>
                </span>
                <span v-if="status === 2 || status === 3" class="btn-control" :title="previewTitle" :class="{disabled: status < 2 || status >= 4}" @click="startPlayRecord">
                    <svg-icon v-if="status !== 3" href="#codelab-record-preview" width="100" height="100"></svg-icon>
                    <svg-icon v-else href="#codelab-record-preview-pause" width="100" height="100"></svg-icon>
                </span>
                <span v-if="status >= 2" class="btn-control delete-btn" :title="deleteTitle" :class="{disabled: status < 2}" @click="deleteRecord">
                    <svg-icon class="normal" href="#codelab-record-delete" width="36" height="36"></svg-icon>
                    <svg-icon class="press" href="#codelab-record-delete-press" width="36" height="36"></svg-icon>
                </span>
            </div>
            <div class="record-duration">
                {{durationText}}
            </div>
        </div>
    </div>
</template>
<script>
const Recorder = window.Recorder;
export default {
    name: "sound-record",
    props: {
        visible: Boolean
    },
    data(){
        return {
            recorder: null,
            duration: null,
            status: 0,
            maxDuration: 30,
            statusTexts: [
                this.$t("text_click_record"),
                this.$t("text_recording"),
                this.$t("text_recorded"),
                this.$t("text_previewing"),
                this.$t("text_uploading"),
                this.$t("text_uploaded")
            ]
        }
    },
    computed: {
        durationText(){
            if(this.duration === null){
                return this.$t("text_record_limit");
            }
            let duration = this.duration;
            let hour = Math.floor(duration / 3600);
            duration -= 3600 * hour;
            let minu = Math.floor(duration / 60);
            
            duration -= minu * 60;
            let sec = Math.floor(duration);
            let text = "";
            if(hour > 0){
                text += hour + ": ";
                text += ((minu < 10 ? "0" + minu : minu) + "' ");
                text += ((sec < 10 ? "0" + sec : sec) + "\"");
            } else {
                if(minu > 0){
                    text += ((minu < 10 ? "0" + minu : minu) + "' ");
                    text += ((sec < 10 ? "0" + sec : sec) + "\"");
                } else {
                    text += ((sec < 10 ? "0" + sec : sec) + "\"");
                }
            }
            return text;
        },
        deleteTitle(){
            if(this.status >= 2){
                return this.$t("text_delete_record");
            }
            return "";
        },
        previewTitle(){
            if(this.status === 2){
                return this.$t("text_play_record");
            } else if(this.status === 3){
                return this.$t("text_pause_play_record");
            }
            return "";
        },
        recordPercent(){
            if(!this.status === 1){
                return 0;
            }
            return ((this.duration || 0) / this.maxDuration) * 100;
        }
    },
    watch: {
        status(value){
            this.$emit("statusChange", value);
        }
    },
    methods: {
        backClick(){
            this.destroyRecorder();
            this.back();
        },
        back(){
            this.$emit("update:visible", false);
        },
        startRecord(){
            if(this.status === 0){
                let recorder = new Recorder();
                recorder.start().then(() => {
                    this.recorder = recorder;
                    this.status = 1;
                    recorder.onprogress = (params) => {
                        if(params.duration >= this.maxDuration){
                            this.stopRecord();
                        }
                        this.duration = params.duration;
                    }
                }, (error) => {
                    this.$message.error(`${error.name} : ${error.message}`);
                    console.log(`${error.name} : ${error.message}`);
                });
            } else {
                this.stopRecord();
            }
            
        },
        stopRecord(){
            this.recorder && this.recorder.stop();
            this.status = 2;
        },
        startPlayRecord(){
            if(this.status < 2){
                return;
            }
            if(this.status === 2){
                this.recorder && (this.recorder.play(), this.status = 3);
            } else if(this.status === 3){
                this.stopPlayRecord();
            }
        },
        stopPlayRecord(){
            this.recorder && (this.recorder.stopPlay(), this.status = 2);
        },
        deleteRecord(){
            if(this.status < 2 || this.status >= 4){
                return;
            }
            this.destroyRecorder();
            this.status = 0;
        },
        getWavBlob(){
            if(this.recorder){
                return this.recorder.getWAVBlob();
            }
            return null;
        },
        destroyRecorder(){
            this.stopPlayRecord();
            this.recorder && this.recorder.destroy && this.recorder.destroy().then(() => {
                console.log("destroy recoder");
                this.recorder = null;
                this.duration = null;
                this.status = 0;
            });
        }
    },
    destroyed(){
        this.destroyRecorder();
    }
}
</script>
<style lang="scss">
    .codelab-sound-record{
        .top{
            width: 100%;
            height: 70px;
            line-height: 70px;
            margin-top: 20px;
            position: relative;
            text-align: center;
            .back{
                display: inline-block;
                width: 26px;
                height: 26px;
                line-height: 26px;
                position: absolute;
                left: 45px;
                top: 22px;
                cursor: pointer;
                svg{
                    fill: #a8a8ac;
                    stroke: #a8a8ac;
                }
                &:hover{
                    svg{
                        stroke: #1BD3FF;
                        fill: #1BD3FF;
                    }
                }
            }
        }
        .record-status,.record-duration{
            width: 100%;
            height: 70px;
            line-height: 70px;
            text-align: center;
            font-size: 12px;
            color: #c8c8c8;
            .status-symbol{
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 5px;
                background: #bc423b;
                vertical-align: middle;
                animation: recording-ani ease-in-out 1.5s infinite;
            }
            .status-text{
                vertical-align: middle;
            }
        }
        .bottom{
            width: 100%;
            height: calc(100% - 90px);
            margin-top: 20px;
            text-align: center;
            position: relative;
            .btn-control{
                cursor: pointer;
                display: inline-block;
                svg{
                    fill: #a8a8ac;
                }
                &:hover{
                    svg{
                        fill: #239AB4;
                    }
                }
                &.disabled{
                    svg{
                        fill: #696969;
                    }
                }
                &.record-btn{
                    width: 100px;
                    height: 100px;
                    line-height: 100px;
                    border-radius: 50px;
                    background: #16B5E3;
                    svg{
                        fill: #c8c8c8;
                    }
                    &:hover{
                        background: #239AB4;
                        svg{
                            stroke: #979797;
                        }
                    }
                    &.active,&:active{
                        svg{
                            fill: #FD7062;
                        }
                    }
                }
                &.stop-record-btn{
                    width: 100px;
                    height: 100px;
                    border-radius: 50px;
                    line-height: 100px;
                    background: #696969;
                    position: relative;
                    &::after{
                        content: "";
                        display: block;
                        width: 40px;
                        height: 40px;
                        border-radius: 5px;
                        background-color: #fe5c4c;
                        position: absolute;
                        left: 30px;
                        top: 30px;
                    }
                    .record-progress {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        z-index: 3;
                        .el-progress-circle {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            margin-left: -50px;
                            margin-top: -50px;
                        }
                    }
                }
                &.delete-btn{
                    width: 60px;
                    height: 60px;
                    border-radius: 30px;
                    position: absolute;
                    line-height: 60px;
                    left: 50%;
                    top: 20px;
                    margin-left: 116px;
                    .normal{
                            display: inline-block;
                        }
                        .press{
                            display: none;
                        }
                    &:hover{
                        .normal{
                            display: none;
                        }
                        .press{
                            display: inline-block;
                        }
                        background: #333333;
                    }
                }
            }
            .record-duration{
                color: #ffffff;
                font-size: 14px;
            }
        }
    }
    @keyframes recording-ani {
        0% {opacity: 1;}
        60% {opacity: 0.2;}
        100% {opacity: 1;}
    }
</style>